module.exports = "\n\n<div *ngIf=\"showTimer\">\n    <span>Time : {{this.countDown}}</span>\n  </div>\n "